export interface Project {
  id: string;
  title: string;
  status: 'Declaración' | 'Evaluación' | 'Protección' | 'Negociación' | 'Licenciado';
  leadInventor: string;
  technologies: string[];
  createdDate: string;
  description?: string;
}

export const mockProjects: Project[] = [
  {
    id: 'proy-001',
    title: 'Sistema de Diagnóstico Médico con IA',
    status: 'Evaluación',
    leadInventor: 'Dr. María González',
    technologies: ['Inteligencia Artificial', 'Machine Learning', 'Salud Digital'],
    createdDate: '2024-10-15T10:00:00Z',
    description: 'Sistema de diagnóstico asistido por IA para detección temprana de enfermedades cardiovasculares.'
  },
  {
    id: 'proy-002',
    title: 'Plataforma de Blockchain para Trazabilidad Agrícola',
    status: 'Protección',
    leadInventor: 'Ing. Carlos Ramírez',
    technologies: ['Blockchain', 'IoT', 'Agricultura'],
    createdDate: '2024-09-20T14:30:00Z',
    description: 'Solución blockchain para garantizar la trazabilidad de productos agrícolas desde el campo hasta el consumidor.'
  },
  {
    id: 'proy-003',
    title: 'Algoritmo de Optimización Energética',
    status: 'Negociación',
    leadInventor: 'Dra. Ana Martínez',
    technologies: ['Energías Renovables', 'Optimización', 'Smart Grids'],
    createdDate: '2024-08-05T09:15:00Z',
    description: 'Algoritmo para optimizar el consumo energético en edificios inteligentes mediante predicción de demanda.'
  },
  {
    id: 'proy-004',
    title: 'Biosensor para Detección de Contaminantes',
    status: 'Licenciado',
    leadInventor: 'Dr. Pedro Sánchez',
    technologies: ['Biotecnología', 'Nanotecnología', 'Medio Ambiente'],
    createdDate: '2024-06-10T11:45:00Z',
    description: 'Biosensor portátil para detección rápida de contaminantes en agua potable.'
  },
  {
    id: 'proy-005',
    title: 'Software de Realidad Aumentada para Educación',
    status: 'Declaración',
    leadInventor: 'Ing. Laura Torres',
    technologies: ['Realidad Aumentada', 'EdTech', 'Desarrollo de Software'],
    createdDate: '2024-11-01T16:20:00Z',
    description: 'Plataforma educativa con realidad aumentada para enseñanza de ciencias en secundaria.'
  },
  {
    id: 'proy-006',
    title: 'Material Compuesto para Construcción Sostenible',
    status: 'Evaluación',
    leadInventor: 'Dr. Roberto Díaz',
    technologies: ['Materiales Avanzados', 'Construcción', 'Sostenibilidad'],
    createdDate: '2024-10-28T08:00:00Z',
    description: 'Nuevo material compuesto biodegradable para construcción con propiedades térmicas superiores.'
  }
];
